export default __webpack_public_path__ + "a593f3811a59b717296df4e2e9bff1bf.png";